import React from 'react'
import { KeywordCombinations } from '../lib/types'

type Props = {
  index: number,
  onClick: () => void,
  item: KeywordCombinations | null,
  randomOffset: number
}

const colorList = [
  // { "backgroundColor": "#007CE4", "color": "#434B59", "isDark": false },
  // { "backgroundColor": "#007CE4", "color": "#C2B49A", "isDark": true  },
  // { "backgroundColor": "#007CE4", "color": "white",   "isDark": true  },
  { "backgroundColor": "#FFE742", "color": "#62575F", "isDark": false },
  { "backgroundColor": "#D43329", "color": "#EEFFFF", "isDark": true  },
  { "backgroundColor": "#F96167",  "color": "#FCE77D", "isDark": true  },
  { "backgroundColor": "#4831D4",  "color": "#CCF381", "isDark": true  },
  { "backgroundColor": "#F0A07C",  "color": "#4A274F", "isDark": true  },
  { "backgroundColor": "#3C1A5B", "color": "#FFF748", "isDark": true  },
  { "backgroundColor": "#FBEAEB", "color": "#2F3C7E", "isDark": false },
  { "backgroundColor": "#1D1B1B", "color": "#EC4D37", "isDark":  true  },
  { "backgroundColor": "#FFE67C", "color": "#295F2D", "isDark": false },
  { "backgroundColor": "#080A52", "color": "#ED2188", "isDark": true  },
  { "backgroundColor": "#E7D045", "color": "#A04EF6", "isDark": false },
  { "backgroundColor": "#234E70", "color": "#FBF8BE", "isDark": false },
  { "backgroundColor": "#CC313D", "color": "#F7C5CC", "isDark": true  },
  { "backgroundColor": "#013DC4", "color": "#E2D3F4", "isDark": false },
  { "backgroundColor": "#DBB98F", "color": "#96351E", "isDark": false },
  { "backgroundColor": "#317773", "color": "#E2D1F9", "isDark": true  },
  { "backgroundColor": "#00FFFF", "color": "#FF69B4", "isDark": false },
  { "backgroundColor": "#635E87", "color": "#CFCAA8", "isDark": true  },
  { "backgroundColor": "#f4b41a",  "color": "#143D59", "isDark": false },
  { "backgroundColor": "#210070",  "color": "#213970", "isDark": true  },
  { "backgroundColor": "#FFE042", "color": "#E71989", "isDark": true  },
  { "backgroundColor": "#FFA781", "color": "#5B0E2D", "isDark": false },
  { "backgroundColor": "#00E1D9", "color": "#5E001F", "isDark": false },
  { "backgroundColor": "#0E387A", "color": "#9FAFCA", "isDark": true  },
  { "backgroundColor": "#A9DCE3", "color": "#7689DE", "isDark": false },
  { "backgroundColor": "#337DEF", "color": "#FCC729", "isDark": true  },
  { "backgroundColor": "#EFC8B1", "color": "#514644", "isDark": false },
  { "backgroundColor": "#BDFFF6", "color": "#E23C52", "isDark": false },
  { "backgroundColor": "#ABD1FF", "color": "#E45B22", "isDark": false },
  { "backgroundColor": "#4955FD", "color": "#A5E300", "isDark": true  },
  { "backgroundColor": "#292826", "color": "#F9D342", "isDark": true  },
  { "backgroundColor": "#1D5C96", "color": "#7DB0DE", "isDark": true  },
  { "backgroundColor": "#5A431B", "color": "#538D5D", "isDark": true  },
  { "backgroundColor": "#64395F", "color": "#C075B7", "isDark": true  },
  { "backgroundColor": "#EBEBDE", "color": "#777764", "isDark": false },
  { "backgroundColor": "#7B4333", "color": "#E9BBBA", "isDark": true  },
  { "backgroundColor": "#CEDEF0", "color": "#9D9AD9", "isDark": false },
  { "backgroundColor": "#3D4C41", "color": "#999999", "isDark": true  },

  { "backgroundColor": "#ffb700", "color": "#5d1d88", "isDark":  false },
  { "backgroundColor": "#fcb61a", "color": "#f4f3f0", "isDark":  true },
  { "backgroundColor": "#ec8b5e", "color": "#141a46", "isDark":  false },
  { "backgroundColor": "#0051ba", "color": "#ffda1a", "isDark":  false },
  { "backgroundColor": "#234E70", "color": "#FBF8BE", "isDark":  true },
  { "backgroundColor": "#ffffff", "color": "#ff671f", "isDark":  false },
  { "backgroundColor": "#005eab", "color": "#f04da1", "isDark":  true },
  { "backgroundColor": "#404040", "color": "#ff0072", "isDark":  true },
  { "backgroundColor": "#000000", "color": "#ffd648", "isDark":  true },
  { "backgroundColor": "#101820", "color": "#FEE715", "isDark":  true },
  { "backgroundColor": "#491586", "color": "#ff0000", "isDark":  true },
  { "backgroundColor": "#a10c94", "color": "#d5e100", "isDark":  true },
  { "backgroundColor": "#ff0006", "color": "#ffffff", "isDark":  false },
  { "backgroundColor": "#eb2188", "color": "#080a52", "isDark":  true },
  { "backgroundColor": "#412722", "color": "#7a4e37", "isDark":  true },
  { "backgroundColor": "#e02122", "color": "#ffd8e1", "isDark":  false },
  { "backgroundColor": "#171718", "color": "#c0ff2d", "isDark":  true },
  { "backgroundColor": "#7A2048", "color": "#1E2761", "isDark":  true },
  { "backgroundColor": "#00933b", "color": "#fccf03", "isDark":  false },
  { "backgroundColor": "#201e20", "color": "#e0a96d", "isDark":  true }
]


const fontFamilies = [
  "'Caveat', cursive",
  "'Lobster Two', cursive",
  "'Quicksand', sans-serif",
  "'Audiowide', cursive",
  "'Barrio', cursive",
  "'Caveat', cursive",
  "'Lobster Two', cursive",
  "'Permanent Marker', cursive",
  "'Quicksand', sans-serif",
  "'Tourney', cursive",
]

function TextNameContainer(props: Props) {

  const randomColorIndex = props.randomOffset + props.index
  const randomFontIndex = Math.abs(props.randomOffset + fontFamilies.length - props.index)

  const randomColor = colorList[randomColorIndex % colorList.length]
  const randomFont = fontFamilies[randomFontIndex % fontFamilies.length]

  return (
    <div key={props.index} className="col-sm-3">
      <div className="nameItem" onClick={props.onClick} style={{ backgroundColor: randomColor.backgroundColor }}>
        <span style={{ color: randomColor.color, fontFamily: randomFont }}>{props.item?.word}</span>
        <span className={`subtext ${randomColor.isDark ? "light" : ""}`}></span>
      </div>
    </div>

  )
}

export default React.memo(TextNameContainer)